import { render } from "./companies-table.vue?vue&type=template&id=14834771"
import script from "./companies-table.vue?vue&type=script&lang=js"
export * from "./companies-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__